import { Component } from 'react';
import { Col } from 'react-bootstrap';
import './header.css';
import { textHelper } from '../../helpers/text';
import SupportButton from '../../components/support_button/SupportButton'

class Header extends Component {
	STEPS_WITHOUT_NAV = [ 'authentication', 'home_without_code' ];

    constructor(props) {
        super(props);
        this.state = {
            plate: props.plate,
            rut: props.rut,
            componentName: props.componentName
        }
    }
	
    componentDidUpdate(prevProps) {
        if (
            this.props.plate !== prevProps.plate
            || this.props.rut !== prevProps.rut
            || this.props.componentName !== prevProps.componentName
        ) {
            this.setState({
                plate: this.props.plate,
                rut: this.props.rut,
                componentName: this.props.componentName
            });
        }
    }

    


    render() {
		const { rut, plate, componentName } = this.state;
        return (
            <div className='header'>
                <div className='sub-header'>
                    <Col xs={2} className='svg-header'>
                        <svg width="25" height="16" viewBox="0 0 25 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.4539 0.451994C24.5194 0.80163 24.5151 1.16069 24.4411 1.50865C24.3672 1.85661 24.2251 2.18664 24.023 2.47985C23.821 2.77305 23.5629 3.02369 23.2635 3.21743C22.9641 3.41117 22.6293 3.5442 22.2782 3.60891L6.04655 6.64253C4.39833 6.94295 3.21571 8.46955 3.44654 10.1204C3.50048 10.5328 3.63698 10.9301 3.84796 11.289C4.05893 11.6478 4.34007 11.9607 4.67472 12.2093C5.00937 12.4578 5.39071 12.6369 5.79611 12.7358C6.20152 12.8348 6.62275 12.8516 7.03481 12.7854C7.44688 12.7191 7.8414 12.5711 8.19497 12.3501C8.54854 12.1291 8.85397 11.8396 9.09314 11.4988C9.33231 11.158 9.50036 10.7728 9.58732 10.3661C9.67427 9.95937 9.67836 9.5394 9.59935 9.13107L9.59444 9.10563C9.3754 7.97634 10.0856 6.87837 11.2152 6.66797L21.0878 4.8204C21.1423 4.80939 21.199 4.82027 21.2455 4.85069C21.2921 4.88111 21.3247 4.92861 21.3363 4.98285C21.46 5.6452 21.3315 6.32971 20.9759 6.90275C20.6202 7.4758 20.063 7.89625 19.413 8.08203C19.3384 8.10258 12.718 9.35419 12.718 9.35419C12.6749 9.36217 12.6362 9.38538 12.609 9.41954C12.5817 9.4537 12.5678 9.49652 12.5697 9.54012C12.6007 10.6888 12.3007 11.8223 11.7052 12.8064C11.1097 13.7905 10.2436 14.584 9.20956 15.093C8.17549 15.602 7.01669 15.8051 5.87032 15.6784C4.72396 15.5517 3.63804 15.1004 2.74111 14.378C1.84418 13.6555 1.17379 12.6922 0.809305 11.602C0.444821 10.5118 0.401501 9.34034 0.684473 8.22637C0.967446 7.11239 1.56486 6.10251 2.406 5.31628C3.24714 4.53004 4.29679 4.00036 5.43068 3.78995L24.2103 0.288569C24.2643 0.278741 24.32 0.290333 24.3655 0.32087C24.411 0.351406 24.4428 0.398466 24.4539 0.451994Z" fill="white"/>
                        </svg>
                    </Col>
                    <Col xs={8}>
                        <p className='title-header'>Proceso de firma digital</p>
                    </Col>
                    <Col xs={2} style={{padding: 0, textAlign: 'right'}}>
                        <SupportButton />
                    </Col>
                </div>
                <div className={`sub-header-ligth ${this.STEPS_WITHOUT_NAV.includes(componentName) ? 'hide': ''}`}>
                    <Col xs={6} className='rut-header'>
                        RUT: {textHelper.formatRut(rut)}
                    </Col>
                    <Col xs={6} className='plate-header'>
                        <strong>Patente: {plate}</strong>
                    </Col>
                </div>
            </div>
        );
    }
}


export default Header;